import React from "react";
import { secondsToHHMM } from "../shared/utils";

const FlightsInterval = props => {
	const renderAirportChange = () => {
		if (props.airportchange) {
			return (
				<li className="small">
					<i className="icon-change" />
					Troca de aeroporto
				</li>
			);
		}
	};

	const renderLayover = () => {
		return (
			<li className="small">
				<i className="icon-clock" />
				Espera de <strong>{secondsToHHMM(props.flightdata.layover * 60)}</strong> em{" "}
				<strong>{props.nexttripfrom}</strong>
			</li>
		);
	}

	return (
		Boolean(props.flightdata.layover) && (
			<div className="flight-item-connection">
				<ul className="list-inline no-margin-bottom">
					{renderLayover()}
					{renderAirportChange()}
				</ul>
			</div>
		)
	);
};

export default FlightsInterval;